import { useCopiedState } from "../../../../core/util/hooks";
import { setFilter, removeFilter, initialState } from "../weeklyTradeUXSlice";
import { setData } from "../weeklyTradeDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";
import { WeeklyTradingReportFilter } from "../types";

export const useWTRFilter = () => {
  const storeFilter = useSelector<StoreType, WeeklyTradingReportFilter>(
    (store) => store.ux.reports.weeklyTrade.filter
  );

  const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState<
    WeeklyTradingReportFilter
  >(storeFilter);

  const dispatch = useDispatch();

  const dispatchSetFilter = React.useCallback(
    (numofweeks: number) => {
      dispatch(setFilter(numofweeks));
      dispatch(setData());
    },
    [dispatch]
  );

  const dispatchResetFilter = React.useCallback(() => {
    setCurrentFilter(initialState.filter);
  }, [setCurrentFilter]);

  return [
    filter,
    editFilter,
    dispatchSetFilter,
    changeState,
    dispatchResetFilter,
  ] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter,
    typeof changeState,
    typeof dispatchResetFilter
  ];
};
